import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-status-cell-renderer',
  templateUrl: './status-cell-renderer.component.html',
  styleUrls: ['./status-cell-renderer.component.scss'],
})
export class StatusCellRendererComponent implements ICellRendererAngularComp {

  public displayValue!: any;
  public field:any;

  agInit(params: ICellRendererParams): void {
    this.displayValue = params.value;
    this.field = params.colDef?.field;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  get _value() {
    if (this.field === "isLocked")
    {
       return this.displayValue ? 'Locked' : 'Un-Locked';
    }
    if (typeof this.displayValue === 'boolean') return this.displayValue ? 'Active' : 'InActive';
    return this.displayValue;
  }


  getStatusColor(status: string): string {
    switch (status) {
      // case 'Pending':
      //   return '#FF965E' // orange
      case 'In Progress':
        return 'inprogress'; // Blue
      case 'Submitted to HMRC':
        return 'submitted-hmrc' // Dark Blue
      // case 'Fully Accepted by HMRC':
      //   return '#578306'; // Green
      case 'In Query by HMRC':
        return 'inquery-hmrc' // Yellow
      case 'Rejected by HMRC':
        return 'rejected-hmrc'; // Red
      // case 'Partially Accepted by HMRC':
      //   return '#8AB141'; // Light Green
      case 'Active':
        return 'active'; // Green
      case 'InActive':
        return 'inactive'; // Red
      case 'Locked':
        return '#8AB141'; // Light Greened
      case 'Resend password':
        return 'resetPassword'; // Light Greened
      case 'Un-Locked':
        return '#28a745'; // Gray
      case 'Locked by Another User':
      default:
        return '#e0e0e0'; // Default color
    }
  }

}
